import { getAxiosInstance } from "../ApiConfig";

async function getCompanyProject() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllProductByCompany`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getMyProject(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyProducts${page ? `?page=${page}&limit=${limit}` : ''}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function AllProductPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyProducts?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllProductSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyProducts?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getSharedProject() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedProducts`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getProjectList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllProductByReportingUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getProductDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByDealProductId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteDealProduct(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteDealProduct/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createDealProduct(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createDealProduct`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateDealProduct(payload, drawerId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateDealProduct/${drawerId}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    createDealProduct,
    deleteDealProduct,
    updateDealProduct,
    getMyProject,
    getCompanyProject,
    getSharedProject,
    getProjectList,
    getProductDetails,
    AllProductPaginationSearch,
    AllProductSearch,
}